import React,{useState} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import TodoApp ,{TodoList} from"./app"
import aaa from'./31.mp3'
import bbb from'./13.mp3'

function App(props) {
let [val,setVal] = useState(0)
let voice1=()=>{
    var audio = new Audio(aaa);
      audio.play();
}
let voice=()=>{
  var audio = new Audio(bbb);
    audio.play();
}
  return (
    <div className="App">
        <center>
          <p>持诵次数:<span>{val}</span> &nbsp;&nbsp;&nbsp;&nbsp; <button herf="#" onClick={()=>{setVal(val=0,voice())}}>重置</button></p>
            <div id="rotate">
            <img onClick={()=>{setVal(val>=108?(voice(),val=0):(voice1(),val+1))}} src={require("./fo.png")}/>
            </div>
        </center>
        
        <TodoApp />
    </div>
    
  );
}
ReactDOM.render(<App />,document.getElementById("root"));
